module.exports = __webpack_public_path__ + "static/media/logout.3a29c29b.svg";